import { TIMEWINDOW_MAX_MAP } from "common/constants";
import { getIndexes } from "common/utils";
import { useRef } from "react";

export function getFieldsAndMap(
    newFieldNamesSet,
    oldFieldsMap,
    colorsSet,
    parsedResponse,
    time,
    timeWindow
  ) {
    const { map, fields } = [...newFieldNamesSet].reduce(
      (acc, bqn, index) => {
        const entry = oldFieldsMap[bqn];
        const color = colorsSet[index];

        if (!entry) {
          const { downlink, uplink } = parsedResponse[bqn];
          const total = getSumValue(downlink) + getSumValue(uplink);
          const newField = {
            name: bqn,
            label: bqn,
            color,
            value: total,
          };
          acc.fields.push(newField);
          acc.map[bqn] = {
            color,
            time,
            total,
          };
        } else {
          const timeFieldNotFound = time.getTime() - entry.time.getTime();
          if (parsedResponse[bqn]) {
            const { downlink, uplink } = parsedResponse[bqn];
            const total = getSumValue(downlink) + getSumValue(uplink);
            acc.map[bqn] = {
              ...entry,
              time,
              total: oldFieldsMap[bqn].total + total,
            };
            const newField = {
              name: bqn,
              label: bqn,
              color,
              value: total,
            };
            acc.fields.push(newField);
          } else if (timeFieldNotFound <= TIMEWINDOW_MAX_MAP[timeWindow]) {
            acc.map[bqn] = entry;
            const newField = {
              name: bqn,
              label: bqn,
              color,
              value: 0,
            };
            acc.fields.push(newField);
          }
        }
        return acc;
      },
      { map: {}, fields: [] }
    );
  
    return { map, fields };
  }

  export function getSumValue(value) {
    if (value === undefined || value === "n/a" || value === null) {
      return 0;
    }
    return Number(value);
}

export function parseHostnames(response) {
  if(!response){
    return {};
  }
  const [header, ...rows] = response.trim().split("\n");
  const headerIndex = getIndexes(header);
  return rows.reduce((acc, value) => {
    const attrs = value.trim().split(/\s+/);
    const bqn = attrs[headerIndex["BQN"]];
    const hostname = attrs[headerIndex["HOSTNAME"]];
    acc[bqn] = hostname;
    return acc;
  }, {});
}

export const useMockStatisticsShort = () => {
  const bytesDownload = useRef(0);
  const bytesUpload = useRef(0);

  return () => {
    bytesDownload.current += (3000 * Math.random());
    bytesUpload.current += 1000;
    return `BQN         EPOCH    TX-BYTES-DN    TX-BYTES-UP    TX-TCP-BYTES TX-TCPO-BYTES    ACTIVE-SUBS    ACTIVE-FLOWS    LATENCY-DN    LATENCY-UP    SHAPED-BYTES-DN    SHAPED-BYTES-UP    RATE-BYTES-DN    RATE-BYTES-UP
241 ${new Date().getTime() + 4*60*60*1000}         ${bytesDownload.current} ${bytesUpload.current}         ${bytesUpload.current}            ${bytesUpload.current}              2               7         0.000         0.000                  0                  0                0                0
  `
  }
}
